<template>
  <div class="data">
    <div class="dataCenter">
      <div class="img">
        <div class="bigP">
          <div class="P1">
            <p class="p11">服务客户</p>
            <p class="p12 wow">
              {{ num }}
              <span class="p13">位</span>
            </p>
          </div>
          <div class="P2">
            <p class="p21">公司成立</p>
            <p class="p22">
              2001
              <span class="p23">年</span>
            </p>
          </div>
          <div class="P3">
            <p class="p31">拥有产品</p>
            <p class="p32">
              1378
              <span class="p33">种</span>
            </p>
          </div>
          <div class="P4">
            <p class="p41">累计销售</p>
            <p class="p42">
              7840
              <span class="p43">件</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { WOW } from "wowjs";
import { GetHF } from "@/https/http";
export default {
  data() {
    return {
      num: 0,
      time: 0,
      data: "",
    };
  },
  created() {
    GetHF().then((res) => {
      console.log("GetHF", res);
      this.data = res.result;
    });
  },
  mounted() {
    window.addEventListener("scroll", this.windowScroll);
    this.$parent.color = `#000`;
    this.$parent.backgroundColor = "#fff";
    let wow = new WOW({
      boxClass: "wow", //需要执行动画的元素的 class
      animateClass: "animated", //animation.css 动画的 class
      offset: 0, //距离可视区域多少开始执行动画
      mobile: true, //是否在移动设备上执行动画
      live: true, //异步加载的内容是否有效
    });
    wow.init();

    this.time = setInterval(() => {
      this.num = this.num + 2;
      if (this.num > 64) {
        clearInterval(this.time);
      }
    }, 20);
  },
  methods: {
    windowScroll() {
      let scrollTop = document.documentElement.scrollTop;
      if (scrollTop > 0) {
        this.top = scrollTop;
        parseInt(this.top);
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.windowScroll);
  },
};
</script>
<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.data {
  width: 100%;
  min-width: 1440px;
  height: 360px;
  margin-top: 55px;
  .dataCenter {
    width: 100%;
    height: 360px;
    min-width: 1440px;
    margin: 0 auto;
    .img {
      min-width: 1440px;
      z-index: 0;
      background-position: center center;
      width: 100%;
      height: 360px;
      background-image: url("../../assets/about/图层 5 拷贝 2.png");
      margin: 0 auto;
      position: absolute;
      .bigP {
        width: 1440px;
        min-width: 1440px;
        height: 200px;
        margin: 0 auto;
        position: relative;
        top: 135px;
        left: 0;
        .P1 {
          float: left;
          width: 150px;
          height: 70px;
          color:#333;
          .p11 {
            width: 65px;
            height: 17px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999;
            line-height: 30px;
            margin-bottom: 10px;
          }
          .p12 {
            width: 160px;
            height: 40px;
            font-size: 50px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #333;
            line-height: 30px;
            float: left;
          }
          .p13 {
            width: 15px;
            height: 14px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999;
            line-height: 30px;
            margin-left: -15px;
          }
        }
        .P2 {
          float: left;
          margin-left: 201px;

          .p21 {
            width: 65px;
            height: 17px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999;
            line-height: 30px;
            margin-bottom: 10px;
          }
          .p22 {
            width: 160px;

            height: 40px;
            font-size: 50px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #333;
            line-height: 30px;
            float: left;
          }
          .p23 {
            width: 15px;
            height: 14px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999;
            line-height: 30px;
            margin-left: -15px;
          }
        }
        .P3 {
          float: left;
          margin-left: 201px;
          .p31 {
            width: 65px;
            height: 17px;
            font-size: 1rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999;
            line-height: 30px;
            margin-bottom: 10px;
          }
          .p32 {
            width: 160px;

            height: 40pxm;
            font-size: 50px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #333;
            line-height: 30px;
            float: left;
          }
          .p33 {
            width: 15px;
            height: 14px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999;
            line-height: 30px;
            margin-left: -15px;
          }
        }
        .P4 {
          float: left;
          margin-left: 201px;

          .p41 {
            width: 65px;
            height: 17px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999;
            line-height: 30px;
          }
          .p42 {
            margin-top: 10px;
            width: 160px;

            height: 40px;
            font-size: 50px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #333;
            line-height: 30px;
            float: left;
          }
          .p43 {
            width: 15px;
            height: 14px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999;
            line-height: 30px;
            margin-left: -15px;
          }
        }
      }
    }
  }
}
</style>